// extracted by mini-css-extract-plugin
export default {"menuBlock":"pI-z","title":"qI-z","nav":"rI-z","flexCell":"sI-z","facetLink":"tI-z"};